let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("j0jcJ")).then(() => parcelRequire('fAtMH'));